import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import PaymentFactory from "../../Entity/Factories/PaymentFactory";
import { ActionInterface } from "../../Interface/ActionInterface";
import { PaymentInterface } from "../../Entity/Entities/Payment/PaymentInterface";
import Translator from "../../Translation/Translator";

export default function* paymentUpdate(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_PAYMENT_UPDATE_CLEAR
    });

    yield put({
      type: Constants.GLOBAL_PAYMENT_UPDATE_REQUEST
    });

    const res = yield call(Http.put, `payment/${action.payload?.paymentId}`, action.payload?.payment);
    const payment: PaymentInterface = PaymentFactory.create(res.data.data);

    yield put({
      type: Constants.GLOBAL_PAYMENT_UPDATE_SUCCESS,
      payload: {
        payment: payment
      }
    });

    yield put({
      type: Constants.GLOBAL_PAYMENTS_LIST_OUTDATE_REQUESTS
    })

    yield put({
      type: Constants.GLOBAL_CHARGES_LIST_OUTDATE_REQUESTS
    })

    if(action.payload?.updateMemo){
      // yield put({
      //   type: Constants.SNACKBAR_ADD_MESSAGE,
      //   payload: {
      //     message: Translator.trans("snackbar-message-charge-memo-updated-successfully"),
      //     type: "success"
      //   }
      // });
    } else if(action.payload?.removeMemo){
      yield put({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: Translator.trans("snackbar-message-charge-memo-removed-successfully"),
          type: "success"
        }
      });
    } else {
      yield put({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: Translator.trans("snackbar-message-payment-updated-successfully"),
          type: "success"
        }
      });
    }

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, payment);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_PAYMENT_UPDATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchPaymentUpdate() {
  yield takeEvery(Constants.GLOBAL_PAYMENT_UPDATE_START, paymentUpdate);
}
